<div class="siteTopBar" id="mat_2">
  <div class="d-flex align-items-center ml-2">
    <a href="javascript:void(0);" routerLink="/">
      <img [src]="images?.remmi_logo" alt="" [ngClass]="mobToggle ? 'mob-logo-img' : 'logo-img'" />
    </a>
  </div>

  <div class="position-relative mt-1 top-search" (click)="toggleSearch()" *ngIf="userRole?.toLowerCase() !== 'contacts' && !mobToggle">
    <div class="search-wrapper">
      <i class="pi pi-search search-icon"></i>
      <input type="text" class="search-input" placeholder="Search" [(ngModel)]="prop_address" (input)="onSearch('global')" />
      <i *ngIf="prop_address" class="pi pi-times clear-icon" (click)="emptySearch()"></i>
    </div>
  </div>

  <div class="topBar-right d-flex align-items-center justify-content-between gap-2">
    <ng-container *ngIf="!mobToggle">
      <div class="height-custom office-width" *ngIf="offices?.length > 1">
        <ng-container *ngTemplateOutlet="officeField"></ng-container>
      </div>

      <div class="height-custom" *ngIf="subOffices?.length">
        <ng-container *ngTemplateOutlet="subOfficeField"></ng-container>
      </div>

      <div class="topBar-notifications tp-dropdown position-relative cursor-pointer">
        <a
          id="notification-dropdown"
          data-bs-toggle="dropdown"
          data-bs-auto-close="true"
          aria-expanded="false"
          class="notification-toggler p-position-relative position-relative">
          <img [src]="images?.notification_icon" alt="notification" width="20px" />
          <span class="nt-p-badge" *ngIf="notifications?.length > 0">{{ notifications?.length }}</span>
        </a>
        <div class="dropdown-menu dropdown-menu-right" aria-labelledby="notification-dropdown">
          <div class="drop-menu-header">
            <div class="today-counter">
              Total
              <p-avatar
                label="{{ notifications?.length }}"
                styleClass="ml-1 p-avatar-small f-12"
                [style]="{ 'background-color': '#f8f9fa', color: '#1a2f45' }">
              </p-avatar>
            </div>
            <div class="mark-all">
              <a href="javascript:void(0)" (click)="readAllNotifications()">Mark all as read</a>
            </div>
          </div>
          <div class="drop-menu-body notifications-list">
            <div class="li" *ngFor="let notification of notifications; trackBy: notificationTrackBy">
              <a
                href="javascript:0;"
                (click)="notificationRead(notification)"
                [routerLink]="notificationTargets.get(notification)?.link"
                [queryParams]="notificationTargets.get(notification)?.queryParams">
                <div class="nt-thumb">
                  <img
                    *ngIf="notification.data.thumb && notification.data.thumb != 'vendor'"
                    [src]="notificationTargets.get(notification)?.thumb"
                    alt="" />
                  <span *ngIf="!notification.data.thumb || notification.data.thumb == 'vendor'">{{
                    notification.data?.sender
                      ? notification.data?.sender?.first_name?.charAt(0) + '' + notification.data?.sender?.last_name?.charAt(0)
                      : 'N/A'
                  }}</span>
                </div>
                <div class="nt-content pl-3">
                  <p class="f-12 _fw-600">{{ notification.data.title }}</p>
                  <p class="f-12" [innerHTML]="notification.data.message"></p>
                  <span class="date-time-notification">{{ notification.data.time * 1000 | amTimeAgo: true }}</span>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>

      <div class="topBar-notifications tp-dropdown">
        <img
          pTooltip="Notes"
          class="cursor-pointer"
          tooltipPosition="bottom"
          id="notes_lis"
          [src]="images?.notes_icon"
          (click)="openNote()"
          alt="notes"
          width="20px" />
      </div>
    </ng-container>

    <div class="mobile-topBar-notifications tp-dropdown cursor-pointer" *ngIf="mobToggle">
      <i class="pi pi-qrcode text-dark" (click)="toggleMobileMenu()"></i>
    </div>

    <!-- Chat lives with the bell and notes rather than in a floating bubble: it is a message source
         like the other two, and unread messages were going unseen at the bottom of the page.
         Outside the `!mobToggle` block on purpose — this replaced the floating button, which was
         the only way into chat on a phone. Self-hides when chat is off or you are already on the
         chat page. -->
    <app-chat-trigger></app-chat-trigger>

    <!-- Sales Assistant "act as agent" switcher (self-hides for non-assistants). -->
    <app-agent-switcher class="mr-2"></app-agent-switcher>

    <div class="mr-2 topBar-profile pl-0 d-flex align-items-center">
      <span class="pr-2">
        Welcome,
        <div class="elips-name">{{ AuthUser?.first_name }}</div>
      </span>
      <div class="tp-dropdown">
        <p-menu #menu1 [popup]="true" [model]="ProfileLinks"></p-menu>
        <div class="dropdown">
          <a (click)="menu1.toggle($event)">
            <div class="user-thumbnail-placeholder">
              <img
                *ngIf="AuthUser && AuthUser.face_photo"
                [src]="
                  AuthUser && AuthUser.face_photo ? AuthUser.face_photo : 'https://remmi-xm.s3-ap-southeast-2.amazonaws.com/photos/thumb_photo_1.png'
                " />
              <span [ngClass]="{ user_thumb: AuthUser && !AuthUser.face_photo }" *ngIf="AuthUser && !AuthUser.face_photo"
                >{{ AuthUser?.first_name?.charAt(0) + '' + AuthUser?.last_name?.charAt(0) }}
              </span>
            </div>
            <i class="pi pi-angle-down pl-2"></i>
          </a>
        </div>
      </div>
    </div>
  </div>

  <div [ngClass]="mobToggle ? 'mobile-save-panel' : 'save-Panel'" *ngIf="addAllModule">
    <i class="pi pi-times cross-icon" (click)="addAllModule = !addAllModule"></i>
    <div style="width: 250px">
      <ng-container *ngTemplateOutlet="moduleField"></ng-container>
    </div>
  </div>
  <div *ngIf="isSearchTrue" [ngClass]="mobToggle ? 'mobile-search-box' : 'search-box'" (clickOutside)="onClickedOutside($event)">
    <div class="mb-2">
      <ng-container *ngTemplateOutlet="moduleField"></ng-container>
    </div>
    <ng-container *ngIf="hasGlobalSearchResults; else noListing">
      <div *ngIf="filteredRecord?.listingData?.length > 0">
        <p class="search-heading d-flex align-items-center">Current Listings</p>
        <div class="loop-item">
          <div *ngFor="let item of filteredRecord?.listingData?.slice(0, itemsToShow)">
            <div class="item-display" (click)="selectItem(); openRightModal(item, 'edit_listing_property')">
              <ng-container *ngIf="item.property_images?.length > 0; else notCurrentListingImage">
                <img src="{{ item.property_images[0] }}" class="yes-images" />
              </ng-container>
              <ng-template #notCurrentListingImage>
                <img [src]="images?.not_found_icon" class="no-images" />
              </ng-template>
              <div class="ml-2">
                <div class="d-flex align-items-center justify-content-between postion-relative">
                  <p [ngClass]="addressLineClass">
                    <b class="f-12">{{ stripAustralia(item.property_address) }}</b>
                  </p>
                  <p class="status-style">{{ item.property_status }}</p>
                </div>
                <p class="mt-1">
                  Agent:
                  <span class="text-captilize">{{ item?.agent?.first_name }}&nbsp;{{ item?.agent?.last_name }}</span>
                </p>
                <p class="mt-1">Type: {{ item.type }}</p>
              </div>
            </div>
          </div>
          <ng-container *ngTemplateOutlet="globalSearchShowMore; context: { total: filteredRecord?.listingData?.length }"></ng-container>
        </div>
      </div>
      <div *ngIf="filteredRecord?.archiveListingData?.length > 0">
        <p class="search-heading d-flex align-items-center">Archived Listings</p>
        <div class="loop-item">
          <div *ngFor="let item of filteredRecord?.archiveListingData?.slice(0, itemsToShow)">
            <div class="item-display" (click)="selectItem(); openRightModal(item, 'edit_listing_property')">
              <ng-container *ngIf="item.property_images?.length > 0; else notArchivedListingImage">
                <img src="{{ item.property_images[0] }}" class="yes-images" />
              </ng-container>
              <ng-template #notArchivedListingImage>
                <img [src]="images?.not_found_icon" class="no-images" />
              </ng-template>
              <div class="ml-2">
                <div class="d-flex align-items-center justify-content-between postion-relative">
                  <p [ngClass]="addressLineClass">
                    <b class="f-12">{{ stripAustralia(item.property_address) }}</b>
                  </p>
                  <p class="status-style">{{ item.property_status }}</p>
                </div>
                <p class="mt-1">
                  Agent:
                  <span class="text-captilize"> {{ item?.agent?.first_name }}&nbsp;{{ item?.agent?.last_name }}</span>
                </p>
                <p class="mt-1">Type: {{ item.type }}</p>
              </div>
            </div>
          </div>
          <ng-container *ngTemplateOutlet="globalSearchShowMore; context: { total: filteredRecord?.archiveListingData?.length }"></ng-container>
        </div>
      </div>
      <div *ngIf="filteredRecord?.market_place?.length > 0">
        <p class="search-heading d-flex align-items-center">Market Place</p>
        <div class="loop-item">
          <div *ngFor="let item of filteredRecord?.market_place?.slice(0, itemsToShow)">
            <div class="item-display" (click)="selectItem(); openRightModal(item, 'market-place')">
              <ng-container *ngIf="item.property_images?.length > 0; else notMarketPlaceImage">
                <img src="{{ item.property_images[0] }}" class="yes-images" />
              </ng-container>
              <ng-template #notMarketPlaceImage>
                <img [src]="images?.not_found_icon" class="no-images" />
              </ng-template>
              <div class="ml-2">
                <div class="d-flex align-items-center justify-content-between postion-relative">
                  <p [ngClass]="addressLineClass">
                    <b class="f-12">{{ stripAustralia(item?.property_address) }}</b>
                  </p>
                  <p class="status-style">{{ item?.property_status }}</p>
                </div>
                <p class="mt-1">
                  Agent:
                  <span class="text-captilize">{{ item?.agent?.first_name }}&nbsp;{{ item?.agent?.last_name }}</span>
                </p>
                <p class="mt-1">Type: {{ item.type }}</p>
              </div>
            </div>
          </div>
          <ng-container *ngTemplateOutlet="globalSearchShowMore; context: { total: filteredRecord?.market_place?.length }"></ng-container>
        </div>
      </div>
      <div *ngIf="filteredRecord?.propertyData?.length > 0">
        <p class="search-heading d-flex align-items-center">Properties</p>
        <div class="loop-item">
          <div *ngFor="let item of filteredRecord?.propertyData?.slice(0, itemsToShow)">
            <div class="item-display" (click)="selectItem(); openRightModal(item, 'edit_property')">
              <ng-container *ngIf="item.property_images?.length > 0; else notPropertyImage">
                <img src="{{ item.property_images[0] }}" class="yes-images" />
              </ng-container>
              <ng-template #notPropertyImage>
                <img [src]="images?.not_found_icon" class="no-images" />
              </ng-template>
              <div class="ml-2">
                <div class="d-flex align-items-center justify-content-between postion-relative">
                  <p [ngClass]="addressLineClass">
                    <b class="f-12">{{ stripAustralia(item.property_address) }}</b>
                  </p>
                  <p class="status-style">{{ item.property_status }}</p>
                </div>
                <p class="mt-1">
                  Agent:
                  <span class="text-captilize"> {{ item?.agent?.first_name }}&nbsp;{{ item?.agent?.last_name }}</span>
                </p>
              </div>
            </div>
          </div>
          <ng-container *ngTemplateOutlet="globalSearchShowMore; context: { total: filteredRecord?.propertyData?.length }"></ng-container>
        </div>
      </div>
      <div *ngIf="filteredRecord?.projects?.length > 0">
        <p class="search-heading d-flex align-items-center">Projects</p>
        <div class="loop-item">
          <div *ngFor="let item of filteredRecord?.projects?.slice(0, itemsToShow)">
            <div class="item-display" (click)="selectItem(); openRightModal(item, 'edit_project')">
              <ng-container *ngIf="item.project_gallery?.length > 0; else notProjectImage">
                <img src="{{ item.project_gallery[0] }}" class="yes-images" />
              </ng-container>
              <ng-template #notProjectImage>
                <img [src]="images?.not_found_icon" class="no-images" />
              </ng-template>
              <div class="ml-2">
                <div class="d-flex align-items-center justify-content-between postion-relative">
                  <p [ngClass]="addressLineClass">
                    <b class="f-12">{{ item.Project_Name }}</b>
                  </p>
                  <p class="status-style" *ngIf="item?.Project_Status">{{ item.Project_Status }}</p>
                </div>
                <div class="d-flex align-items-center">
                  <p class="mt-1">Price:</p>
                  <p class="mt-1 ml-1" *ngIf="item?.min_price_range">{{ item?.min_price_range | currency: 'symbol' : '1.0-0' }} -</p>
                  <p class="mt-1 ml-1" *ngIf="item?.max_price_range">
                    {{ item?.max_price_range | currency: 'symbol' : '1.0-0' }}
                  </p>
                </div>
                <p class="mt-1">Project Manager: {{ item.project_manager?.full_name }}</p>
              </div>
            </div>
          </div>
          <ng-container *ngTemplateOutlet="globalSearchShowMore; context: { total: filteredRecord?.projects?.length }"></ng-container>
        </div>
      </div>
      <div *ngIf="filteredRecord?.units?.length > 0">
        <p class="search-heading d-flex align-items-center">Lots</p>
        <div class="loop-item">
          <div *ngFor="let item of filteredRecord?.units?.slice(0, itemsToShow)">
            <div class="item-display" (click)="selectItem(); openRightModal(item, 'edit_unit')">
              <ng-container *ngIf="item.project_gallery?.length > 0; else notUnitImage">
                <img src="{{ item.project_gallery[0] }}" class="yes-images" />
              </ng-container>
              <ng-template #notUnitImage>
                <img [src]="images?.not_found_icon" class="no-images" />
              </ng-template>
              <div class="ml-2">
                <div class="d-flex align-items-center justify-content-between postion-relative">
                  <p [ngClass]="addressLineClass">
                    <b class="f-12">{{ item.project_name }}</b>
                  </p>
                  <p class="status-style" *ngIf="item?.status_reason">{{ item.status_reason }}</p>
                </div>
                <div class="d-flex align-items-center">
                  <p class="mt-1">Lot:</p>
                  <p class="mt-1 ml-1" *ngIf="item?.lot_name">{{ item?.lot_name }}</p>
                </div>
                <div class="d-flex align-items-center">
                  <p class="mt-1">Price:</p>
                  <p class="mt-1 ml-1" *ngIf="item?.lot_price">
                    {{ item?.lot_price | currency: 'symbol' : '1.0-0' }}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <ng-container *ngTemplateOutlet="globalSearchShowMore; context: { total: filteredRecord?.units?.length }"></ng-container>
        </div>
      </div>
      <div *ngIf="filteredRecord?.contacts?.length > 0">
        <p class="search-heading d-flex align-items-center">Contacts</p>
        <div class="loop-item">
          <div *ngFor="let item of filteredRecord?.contacts?.slice(0, itemsToShow)">
            <div class="item-display" (click)="selectItem(); openRightModal(item, 'edit_contact')">
              <ng-container *ngIf="item?.photo; else noImg">
                <img src="{{ S3Path + item?.photo }}" class="agent-title-home" />
              </ng-container>
              <ng-template #noImg>
                <div *ngIf="item?.first_name && item?.last_name; else noFirstLast">
                  <p class="agent-title-home" title="{{ item?.full_name }}">
                    {{ item?.first_name?.charAt(0) + '' + item?.last_name?.charAt(0) }}
                  </p>
                </div>
                <ng-template #noFirstLast>
                  <p class="agent-title-home" title="{{ item?.full_name }}">
                    {{ item?.full_name?.charAt(0) }}
                  </p>
                </ng-template>
              </ng-template>
              <div class="ml-2">
                <div class="d-flex align-items-center justify-content-between postion-relative">
                  <p [ngClass]="addressLineClass">
                    <b class="f-12">{{ item.full_name }}</b>
                  </p>
                  <p class="status-style">{{ item.contact_type }}</p>
                </div>
                <p class="mt-1">
                  Email: <span>{{ item?.email }}</span>
                </p>
                <p class="mt-1">Mobile: {{ item.mobile_no }}</p>
              </div>
            </div>
          </div>
          <ng-container *ngTemplateOutlet="globalSearchShowMore; context: { total: filteredRecord?.contacts?.length }"></ng-container>
        </div>
      </div>
      <div *ngIf="filteredRecord?.contracts?.length > 0">
        <p class="search-heading d-flex align-items-center">Contracts</p>
        <div class="loop-item">
          <div *ngFor="let item of filteredRecord?.contracts?.slice(0, itemsToShow)">
            <div class="item-display" (click)="selectItem(); openRightModal(item, 'edit_contract')">
              <ng-container *ngIf="item.property_images?.length > 0; else notContractImage">
                <img src="{{ item.property_images[0] }}" class="yes-images" />
              </ng-container>
              <ng-template #notContractImage>
                <img [src]="images?.not_found_icon" class="no-images" />
              </ng-template>
              <div class="ml-2">
                <div class="d-flex align-items-center justify-content-between postion-relative">
                  <p [ngClass]="addressLineClass">
                    <b class="f-12">{{ item.property_address }}</b>
                  </p>
                  <p class="status-style">{{ item.contractStatus }}</p>
                </div>
                <p class="mt-1">Purchaser: {{ item?.buyer[0]?.full_name }}</p>
                <p class="mt-1">Seller: {{ item?.seller[0]?.full_name }}</p>
                <ng-container *ngIf="item.settlement; else noSettlement">
                  <p class="mt-1">Settlement Date: {{ item.settlement | date: 'dd/MM/yy' }}</p>
                </ng-container>
                <ng-template #noSettlement>
                  <p class="mt-1">Contract Date: {{ item.contractDate | date: 'dd/MM/yy' }}</p>
                </ng-template>
              </div>
            </div>
          </div>
          <ng-container *ngTemplateOutlet="globalSearchShowMore; context: { total: filteredRecord?.contracts?.length }"></ng-container>
        </div>
      </div>
      <div *ngIf="filteredRecord?.tasks?.length > 0">
        <p class="search-heading d-flex align-items-center">Tasks</p>
        <div class="loop-item">
          <div *ngFor="let item of filteredRecord?.tasks?.slice(0, itemsToShow)">
            <div class="item-display" (click)="selectItem(); openRightModal(item, 'edit_task')">
              <div *ngIf="item?.title">
                <p class="agent-title-home" title="{{ item?.title }}">
                  {{ item?.title?.charAt(0) }}
                </p>
              </div>
              <ng-template #noFirstLast>
                <p class="agent-title-home" title="{{ item?.title }}"></p>
              </ng-template>
              <div class="ml-2">
                <div class="d-flex align-items-center justify-content-between postion-relative">
                  <p [ngClass]="addressLineClass">
                    <b class="f-12">{{ item.title }}</b>
                  </p>
                  <p class="status-style">{{ item.task_status }}</p>
                </div>
                <p class="mt-1">
                  Creator: <span>{{ item?.creator }}</span>
                </p>
                <p class="mt-1">Due Date: {{ item.due_date | date: 'dd/MM/yy' }}</p>
              </div>
            </div>
          </div>
          <ng-container *ngTemplateOutlet="globalSearchShowMore; context: { total: filteredRecord?.tasks?.length }"></ng-container>
        </div>
      </div>
      <div *ngIf="filteredRecord?.leads?.length > 0">
        <p class="search-heading d-flex align-items-center">Leads</p>
        <div class="loop-item">
          <div *ngFor="let item of filteredRecord?.leads?.slice(0, itemsToShow)">
            <div class="item-display" (click)="selectItem(); openRightModal(item, 'edit_lead')">
              <div *ngIf="item?.full_name">
                <p class="agent-title-home" title="{{ item?.full_name }}">
                  {{ item?.full_name?.charAt(0) }}
                </p>
              </div>
              <ng-template #noFirstLast>
                <p class="agent-title-home" title="{{ item?.full_name }}"></p>
              </ng-template>
              <div class="ml-2">
                <div class="d-flex align-items-center justify-content-between postion-relative">
                  <p [ngClass]="addressLineClass">
                    <b class="f-12">{{ item.full_name }}</b>
                  </p>
                  <p class="status-style">{{ item.lead_status }}</p>
                </div>
                <p class="mt-1">
                  Lead Type:
                  <span>{{ item?.listing_detail ? item?.listing_detail?.property_address : item?.project_detail?.Project_Name }}</span>
                </p>
                <p class="mt-1">
                  Lead Date: <span>{{ item?.created_at | date: 'dd/MM/yy' }}</span>
                </p>
              </div>
            </div>
          </div>
          <ng-container *ngTemplateOutlet="globalSearchShowMore; context: { total: filteredRecord?.leads?.length }"></ng-container>
        </div>
      </div>
      <div *ngIf="filteredRecord?.eoi?.length > 0">
        <p class="search-heading d-flex align-items-center">EOI</p>
        <div class="loop-item">
          <div *ngFor="let item of filteredRecord?.eoi?.slice(0, itemsToShow)">
            <div class="item-display" (click)="selectItem(); openRightModal(item, 'edit_EOI')">
              <ng-container *ngIf="item.project_gallery?.length > 0; else notEOIImage">
                <img src="{{ item.project_gallery[0] }}" class="yes-images" />
              </ng-container>
              <ng-template #notEOIImage>
                <img [src]="images?.not_found_icon" class="no-images" />
              </ng-template>
              <div class="ml-2">
                <div class="d-flex align-items-center justify-content-between postion-relative">
                  <p [ngClass]="addressLineClass">
                    <b class="f-12">{{ item.project_name }}</b>
                  </p>
                  <p class="status-style">{{ item.status_reason }}</p>
                </div>
                <p class="mt-1">Lot: {{ item?.lot_name }}</p>
                <p class="mt-1">Purchaser 1: {{ item?.purchaser_1[0]?.full_name }}</p>
                <p class="mt-1">Purchaser 2: {{ item?.purchaser_2[0]?.full_name }}</p>
                <ng-container *ngIf="item.cancelled_date; else receiveDate">
                  <p class="mt-1">Cancelled Date: {{ item.cancelled_date | date: 'dd/MM/yy' }}</p>
                </ng-container>
                <ng-template #receiveDate>
                  <p class="mt-1">Received Date: {{ item.date_received | date: 'dd/MM/yy' }}</p>
                </ng-template>
              </div>
            </div>
          </div>
          <ng-container *ngTemplateOutlet="globalSearchShowMore; context: { total: filteredRecord?.eoi?.length }"></ng-container>
        </div>
      </div>
      <div *ngIf="filteredRecord?.staff?.length > 0">
        <p class="search-heading d-flex align-items-center">Staff</p>
        <div class="loop-item">
          <div *ngFor="let item of filteredRecord?.staff?.slice(0, itemsToShow)">
            <div class="item-display" (click)="selectItem(); openRightModal(item, 'edit_staff')">
              <ng-container *ngIf="item?.photo; else noStaffImg">
                <img src="{{ S3Path + item?.photo }}" class="agent-title-home" />
              </ng-container>
              <ng-template #noStaffImg>
                <p class="agent-title-home" title="{{ item?.full_name }}">
                  {{ item?.first_name?.charAt(0) + '' + item?.last_name?.charAt(0) }}
                </p>
              </ng-template>
              <div class="ml-2">
                <div class="d-flex align-items-center justify-content-between postion-relative">
                  <p [ngClass]="addressLineClass">
                    <b class="f-12">{{ item.full_name }}</b>
                  </p>
                  <p class="status-style">{{ item.role }}</p>
                </div>
                <p class="mt-1">
                  Email: <span>{{ item?.email }}</span>
                </p>
                <p class="mt-1">Status: {{ item.deactive == true ? 'Deactivated' : 'Active' }}</p>
              </div>
            </div>
          </div>
          <ng-container *ngTemplateOutlet="globalSearchShowMore; context: { total: filteredRecord?.staff?.length }"></ng-container>
        </div>
      </div>
      <div *ngIf="filteredRecord?.deactiveStaff?.length > 0">
        <p class="search-heading d-flex align-items-center">Deactivated Staff</p>
        <div class="loop-item">
          <div *ngFor="let item of filteredRecord?.deactiveStaff?.slice(0, itemsToShow)">
            <div class="item-display" (click)="selectItem(); openRightModal(item, 'edit_staff')">
              <ng-container *ngIf="item?.photo; else noDeactiveStaffImg">
                <img src="{{ S3Path + item?.photo }}" class="agent-title-home" />
              </ng-container>
              <ng-template #noDeactiveStaffImg>
                <p class="agent-title-home" title="{{ item?.full_name }}">
                  {{ item?.first_name?.charAt(0) + '' + item?.last_name?.charAt(0) }}
                </p>
              </ng-template>
              <div class="ml-2">
                <div class="d-flex align-items-center justify-content-between postion-relative">
                  <p [ngClass]="addressLineClass">
                    <b class="f-12">{{ item.full_name }}</b>
                  </p>
                  <p class="status-style">{{ item.role }}</p>
                </div>
                <p class="mt-1">
                  Email: <span>{{ item?.email }}</span>
                </p>
                <p class="mt-1">Status: {{ item.deactive == true ? 'Deactivated' : 'Active' }}</p>
              </div>
            </div>
          </div>
          <ng-container *ngTemplateOutlet="globalSearchShowMore; context: { total: filteredRecord?.deactiveStaff?.length }"></ng-container>
        </div>
      </div>
    </ng-container>
    <ng-template #noListing>
      <ng-container *ngIf="userRole?.toLowerCase() !== 'contacts'">
        <div class="p-3 d-flex align-items-center">
          <p class="text-dark f-14">There are no results</p>
        </div>
      </ng-container>
    </ng-template>
  </div>

  <ng-container *ngIf="listing_preview_id">
    <app-preview-listing #previewModel [id]="listing_preview_id.asObservable()"></app-preview-listing>
  </ng-container>

  <div class="mobile-menu" *ngIf="isMobileMenuOpen">
    <div class="d-block align-items-center" *ngIf="mobToggle">
      <div class="position-relative mt-1">
        <i class="pi pi-search mobile-search-icon"></i>
        <input
          type="text"
          [(ngModel)]="prop_address"
          placeholder="Search"
          class="mobile-auto-width mobile-header-search ml-0"
          style="border-radius: 71px !important; font-size: 14px !important"
          (input)="onSearch('global')" />
        <i class="fa fa-times dollar-icon" *ngIf="prop_address" (click)="emptySearch()"></i>
      </div>
    </div>

    <div class="d-block height-custom mt-1 mb-2 office-width {{ mobToggle ? 'mr-2' : 'mr-4' }}" *ngIf="mobToggle && offices?.length > 1">
      <ng-container *ngTemplateOutlet="officeField"></ng-container>
    </div>

    <div class="d-block height-custom mt-1 mb-2 office-width {{ mobToggle ? 'mr-2' : 'mr-4' }}" *ngIf="mobToggle && subOffices?.length">
      <ng-container *ngTemplateOutlet="subOfficeField"></ng-container>
    </div>

    <div class="topBar-right d-flex align-items-center {{ mobToggle ? 'mr-2 justify-content-around' : 'mr-4 justify-content-between' }}">
      <ng-container *ngIf="AuthUser?.role?.toLowerCase() === 'contacts'; else otherRole">
        <div class="topBar-notifications tp-dropdown border-0 cursor-pointer" *ngIf="mobToggle">
          <div class="dropdown">
            <a
              id="notification-dropdown"
              data-bs-toggle="dropdown"
              data-bs-auto-close="true"
              aria-expanded="false"
              class="notification-toggler p-position-relative">
              <i class="pi pi-bell"></i>
              <span class="nt-p-badge" *ngIf="notifications?.length > 0">{{ notifications?.length }}</span>
            </a>
            <div class="dropdown-menu dropdown-menu-right" aria-labelledby="notification-dropdown">
              <div class="drop-menu-header">
                <div class="today-counter">
                  Total
                  <p-avatar
                    label="{{ notifications?.length }}"
                    styleClass="ml-1 p-avatar-small f-12"
                    [style]="{ 'background-color': '#f8f9fa', color: '#1a2f45' }">
                  </p-avatar>
                </div>
                <div class="mark-all">
                  <a href="javascript:void(0)" (click)="readAllNotifications()">Mark all as read</a>
                </div>
              </div>
              <div class="drop-menu-body notifications-list">
                <div class="li" *ngFor="let notification of notifications; trackBy: notificationTrackBy">
                  <a
                    href="javascript:0;"
                    (click)="notificationRead(notification)"
                    [routerLink]="notificationTargets.get(notification)?.link"
                    [queryParams]="notificationTargets.get(notification)?.queryParams">
                    <div class="nt-thumb">
                      <!-- If Have Image -->
                      <img
                        *ngIf="notification.data.thumb && notification.data.thumb != 'vendor'"
                        [src]="notificationTargets.get(notification)?.thumb"
                        alt="" />
                      <!-- Else 1st two Letters -->
                      <span *ngIf="!notification.data.thumb || notification.data.thumb == 'vendor'">{{
                        notification.data?.sender
                          ? notification.data?.sender?.first_name?.charAt(0) + '' + notification.data?.sender?.last_name?.charAt(0)
                          : 'N/A'
                      }}</span>
                    </div>
                    <div class="nt-content pl-3">
                      <p class="f-12">
                        <b>{{ notification.data.title }}</b>
                      </p>
                      <p class="f-12" [innerHTML]="notification.data.message"></p>
                      <span class="date-time-notification">{{ notification.data.time * 1000 | amTimeAgo: true }}</span>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-container>

      <ng-template #otherRole>
        <div class="topBar-notifications tp-dropdown cursor-pointer" *ngIf="mobToggle">
          <div class="dropdown" style="right: 3px; bottom: 2px">
            <a
              id="notification-dropdown"
              data-bs-toggle="dropdown"
              data-bs-auto-close="true"
              aria-expanded="false"
              class="notification-toggler p-position-relative">
              <img [src]="images?.notification_icon" alt="notification" width="24px" height="24px" />
              <span class="nt-p-badge" *ngIf="notifications?.length > 0">{{ notifications?.length }}</span>
            </a>
            <div class="dropdown-menu dropdown-menu-right" aria-labelledby="notification-dropdown">
              <div class="drop-menu-header">
                <div class="today-counter">
                  Total
                  <p-avatar
                    label="{{ notifications?.length }}"
                    styleClass="ml-1 p-avatar-small f-12"
                    [style]="{ 'background-color': '#f8f9fa', color: '#1a2f45' }">
                  </p-avatar>
                </div>
                <div class="mark-all">
                  <a href="javascript:void(0)" (click)="readAllNotifications()">Mark all as read</a>
                </div>
              </div>
              <div class="drop-menu-body notifications-list">
                <div class="li" *ngFor="let notification of notifications; trackBy: notificationTrackBy">
                  <a
                    href="javascript:0;"
                    (click)="notificationRead(notification)"
                    [routerLink]="notificationTargets.get(notification)?.link"
                    [queryParams]="notificationTargets.get(notification)?.queryParams">
                    <div class="nt-thumb">
                      <img
                        *ngIf="notification.data.thumb && notification.data.thumb != 'vendor'"
                        [src]="notificationTargets.get(notification)?.thumb"
                        alt="" />
                      <span *ngIf="!notification.data.thumb || notification.data.thumb == 'vendor'">{{
                        notification.data?.sender
                          ? notification.data?.sender?.first_name?.charAt(0) + '' + notification.data?.sender?.last_name?.charAt(0)
                          : 'N/A'
                      }}</span>
                    </div>
                    <div class="nt-content pl-3">
                      <p class="f-12">
                        <b>{{ notification.data.title }}</b>
                      </p>
                      <p class="f-12" [innerHTML]="notification.data.message"></p>
                      <span class="date-time-notification">{{ notification.data.time * 1000 | amTimeAgo: true }}</span>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="topBar-notifications tp-dropdown" *ngIf="mobToggle">
          <img
            pTooltip="Notes"
            class="cursor-pointer"
            tooltipPosition="bottom"
            id="notes_lis"
            [src]="images?.notes_icon"
            (click)="openNote()"
            alt="notes"
            width="24px"
            height="24px"
            style="position: relative; right: 3px; bottom: 2px" />
        </div>
      </ng-template>
    </div>
  </div>
</div>

<!-- #region Note — kept OUTSIDE .siteTopBar so its fixed panel isn't trapped in that
     low (z-index:7) stacking context and can layer above page dialogs (e.g. lead detail). -->
<app-header-notes></app-header-notes>

<ng-template #globalSearchShowMore let-total="total">
  <p *ngIf="total != null && itemsToShow < total" class="text-center f-14 mt-3 mb-3 cursor-pointer" (click)="showMore(prop_address)">
    Show more results for <span class="valueColor">{{ prop_address }}</span>
  </p>
</ng-template>

<ng-template #officeField>
  <ng-select
    [items]="offices"
    [(ngModel)]="activeOffice"
    bindLabel="name"
    bindValue="id"
    [multiple]="false"
    [searchable]="true"
    [clearable]="false"
    placeholder="Select Office"
    [ngModelOptions]="{ standalone: true }"
    class="_select"
    style="width: 150px"
    (change)="updateUserOffice()">
    <ng-template ng-label-tmp let-item="item">
      <div class="d-flex align-items-center justify-content-between">
        <p>{{ item.name }}</p>
      </div>
    </ng-template>
    <ng-template ng-option-tmp let-item="item">
      <div class="d-flex align-items-center justify-content-between">
        <p>{{ item.name }}</p>
        <p *ngIf="item.new_leads_count" [ngClass]="item.new_leads_count.toString().length === 1 ? 'single-lead' : 'alert-lead'">
          {{ item.new_leads_count }}
        </p>
      </div>
    </ng-template>
  </ng-select>
</ng-template>

<ng-template #subOfficeField>
  <ng-select
    [items]="subOffices"
    [(ngModel)]="activeSubOffices"
    bindLabel="office_name"
    bindValue="_id"
    [multiple]="true"
    [searchable]="true"
    [clearable]="true"
    [closeOnSelect]="false"
    [disabled]="!subOffices?.length"
    placeholder="Select Offices"
    [ngModelOptions]="{ standalone: true }"
    class="_select sub-office-select"
    style="width: 200px"
    (change)="updateActiveSubOffices()">
    <!-- Selected items collapse to one chip + a count so the header keeps a single row. -->
    <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
      <div class="so-label">
        <span class="so-chip" [pTooltip]="items[0].office_name" tooltipPosition="bottom">
          <span class="so-chip__text">{{ items[0].office_name }}</span>
          <span class="so-chip__x" (click)="clear(items[0])">×</span>
        </span>
        <span class="so-count" *ngIf="items.length > 1" [pTooltip]="subOfficeNames(items)" tooltipPosition="bottom"> +{{ items.length - 1 }} </span>
      </div>
    </ng-template>
    <ng-template ng-option-tmp let-item="item" let-item$="item$">
      <div class="d-flex align-items-center gap-2">
        <p>{{ item.office_name }}</p>
      </div>
    </ng-template>
  </ng-select>
</ng-template>

<ng-template #moduleField>
  <ng-select
    #officeSelect
    [items]="global_module"
    bindLabel="module_name"
    bindValue="module_value"
    [searchable]="true"
    [multiple]="false"
    (change)="selectModule($event)"
    [(ngModel)]="globalFilterModule"
    name="module"
    id="module"
    placeholder="Select Module"
    [clearable]="true"
    class="_select">
    <ng-container *ngFor="let module of global_module">
      <ng-option *ngFlag="module.flag" [value]="module.module_value">
        {{ module.module_name }}
      </ng-option>
    </ng-container>
  </ng-select>
</ng-template>

<!-- Help drawer removed with the header's help button — Remmi AI covers this now. -->

<!-- Project A agent signup — auto-opens hourly while requests exist -->

<app-signup-requests-popup></app-signup-requests-popup>
